import { ADDRESSCLOUD_ENV } from '../constants'

/** Class representing auth service. */
export default class AuthAPI {

  /**
   * @description
   * Gets user profile from Auth service.
   */
  async getProfile() {
    try {
      const url = `https://${ADDRESSCLOUD_ENV}.addresscloud.com/auth/v1/profile/apps/admin`
      const resp = await fetch(url, { mode: 'cors', headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}`}})
      return resp.json()
    } catch(err) {
      console.error(err)
      throw err
    }
  }

  /**
   * @description
   * Gets user profile from Auth service.
   */
  async getKey() {
    try {
      const url = `https://${ADDRESSCLOUD_ENV}.addresscloud.com/auth/v1/key/apps`
      const resp = await fetch(url, { mode: 'cors', headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}`}})
      return resp.json()
    } catch(err) {
      console.error(err)
      throw err
    }
  }

}
